/**
 * CardShowcaseSkeleton - Loading skeleton for card showcase section
 *
 * Displays placeholder content while card data is loading.
 */
import type { ReactElement } from 'react';

export default function CardShowcaseSkeleton(): ReactElement {
  return (
    <div className="p-6">
      {/* Card Image Skeleton - full width */}
      <div className="bg-slate mb-5 aspect-488/680 w-full animate-pulse rounded-xl" />

      {/* Card Info Skeleton */}
      <div className="bg-slate/50 border-storm rounded-xl border p-4">
        {/* Card Name + Mana Cost */}
        <div className="mb-2 flex items-center gap-2">
          <div className="bg-slate h-6 w-40 animate-pulse rounded" />
          <div className="bg-slate h-5 w-12 animate-pulse rounded" />
        </div>

        {/* Type Line */}
        <div className="bg-slate h-4 w-32 animate-pulse rounded" />

        {/* Divider */}
        <div className="bg-storm my-3 h-px" />

        {/* Oracle Text Lines */}
        <div className="space-y-2">
          <div className="bg-slate h-4 w-full animate-pulse rounded" />
          <div className="bg-slate h-4 w-5/6 animate-pulse rounded" />
          <div className="bg-slate h-4 w-4/6 animate-pulse rounded" />
        </div>

        {/* Divider */}
        <div className="bg-storm my-3 h-px" />

        {/* Set + Rarity Row */}
        <div className="flex items-center gap-2">
          <div className="bg-slate h-4 w-24 animate-pulse rounded" />
          <div className="bg-slate h-4 w-8 animate-pulse rounded" />
          <div className="bg-slate h-4 w-16 animate-pulse rounded" />
        </div>
      </div>
    </div>
  );
}
